export default __webpack_public_path__ + "static/media/done.icon.682cf8f4.svg";